import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import Product from "emun.shopping/product.model";
import ProductConfig from "emun.products/product.config";

export default class ProductParserController {
  constructor(options) {
    const $ctrl = this;
    //console.debug("ProductParserController", { $ctrl, options });
    basicController($ctrl);
    $ctrl.queryOptions = {};
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
    const memo = {};
    const skus = ($ctrl.skus || "NO_PRODUCT_ID")
      .split(/[\s,]+/gi)
      .filter(sku => !!sku);
    const request = {
      IdIn: [],
      OrderedSkus: [],
      take: 1000,
      fields: $ctrl.returnProducts ? null : "Id",
      ...$ctrl.queryOptions
    };
    if ($ctrl.$session.isAgency() && !ProductConfig.productParserIdIn) {
      request.IdIn = undefined;
      request.ManufacturerNumberIn = [];
    }
    console.info("sku", { skus, request });
    skus.forEach(sku => {
      if (!memo[sku]) {
        memo[sku] = true;
        if ($ctrl.$session.isAgency() && !ProductConfig.productParserIdIn) request.ManufacturerNumberIn.push(sku);
        else request.IdIn.push(sku);
        request.OrderedSkus.push(sku);
      }
    });
   return $ctrl.bus
      .send(`QueryProducts.json?op=ProductParser&${$ctrl.$session.isRepOrAbove() ? "IncludeInactive=true" : "Status=Active"}`, request)
      .then(({ data }) => {
        console.debug("QueryProducts.json?op=ProductParser", {
          ...data,
          request,
          $ctrl
        });
        if ($ctrl.returnProducts) {
      return    $ctrl.$close(data.results.map(p => new Product(p)));
        } else {
          const map = data.results.reduce(
            (m, p) => Object.assign(m, { [p.id]: 1 }),
            {}
          );
          if ($ctrl.$session.isAgency() && !ProductConfig.productParserIdIn) return $ctrl.$close(request.IdIn.filter(sku => !!map[sku]));
          else return $ctrl.$close(request.ManufacturerNumberIn.filter(sku => !!map[sku]));
        }
      });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
